import React from 'react'
import Skeleton from 'react-loading-skeleton';

export const BannerSkeletonTemplateWrapper = (props: any) => {
  const {secondaryColor} = props;
  const SkeletonStatBox = () => {
    return (
        
        <div className='banner-skeleton' style={{border: `1px solid ${secondaryColor ? secondaryColor : "#e7e6eb"}`}}>
            <Skeleton
                className="skeletonStyle"
            />
        </div>
    );
}

  return (

      <>
      <SkeletonStatBox />
      </>
  )
}
